import React, { useRef, useEffect, useState } from "react";
import gsap from "gsap";
// import gsap from "@motion";  // TODO: to hide this framework on wappalyzer detection
import Animation01 from "@/assets/videos/animation-mob.mp4"
import Animation02 from "@/assets/videos/animation02.mp4"
import Animation03 from "@/assets/videos/animation03.mp4"
import OpeningGateDesk from "@/assets/videos/opening-gate02.mp4"
import OpeningGateMob from "@/assets/videos/opening-gate-mob.mp4"
import OpeningGateTablet from "@/assets/videos/opening-gate03.mp4"
import OpeningGateReversed from "@/assets/videos/opening-gate02-reversed.mp4"
import OpeningGateMobReversed from "@/assets/videos/opening-gate-mob-reversed.mp4"
import OpeningGateTabletReversed from "@/assets/videos/opening-gate03-reversed.mp4"
import { useGlobalContext } from "@/global/GlobalContext";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { bioPs, tiles } from "@/app/utils/constants";
import "@/assets/css/monkey-layout.css"

const MonkeyAnimationComponent = ({ loadingStatus }) => {
  const animationVideo = useRef(null)
  const { setIsToggled, isToggled, openGapura, setOpenGapura, isShowBG, setIsShowBG, initial, showEnterFont, setShowEnterFont, setDisabledDropdown } = useGlobalContext()
  const bioContainerRef = useRef(null)
  const openingGateRef = useRef(null)
  const closingGateRef = useRef(null)
  const bioContentRef = useRef(null)
  const [isHover, setIsHover] = useState(false)
  const enterBtnRef = useRef(null)
  // check media query
  const [currWindowWidth, setCurrWindowWidth] = useState(window.innerWidth)
  const screenW = screen.width
  const tileSizes = "(min-width: 1536px) 200px, (min-width: 1024px) 160px, (min-width: 640px) 120px, 80px"

  // TODO: nanti boleh diperbaiki ini, soalnya aku dapat beberapa sumber web yg bisa autoplay videonya, coba cari caranya
  useEffect(() => {
    if (loadingStatus == "exit") {
      if (animationVideo.current) {
        const timer = setTimeout(() => {
          animationVideo.current.play();
        }, 1000)

        const timer2 = setTimeout(() => {
          setShowEnterFont(true)
        }, 13000)

        animationVideo.current.addEventListener("ended", () => {
          setIsShowBG(true)
        });

        return () => { clearTimeout(timer); clearTimeout(timer2); };
      }
    }
  }, [loadingStatus, animationVideo]);

  useEffect(() => {
    if (openGapura) {
      openingGateRef.current.play()
      setDisabledDropdown(true)
      if (Math.floor(closingGateRef.current.currentTime) > 0) closingGateRef.current.currentTime = 0;

      let ctx2 = gsap.context(() => {
        const tl = gsap.timeline()
        tl.to(enterBtnRef.current, {
          display: "none",
          duration: .1
        })
        tl.to(bioContainerRef.current, {
          delay: .5,
          duration: 1.3,
          scaleX: 1,
        }, "<")
        tl.to(bioContentRef.current, {
          delay: 1,
          duration: 1,
          opacity: 1
        }, "<")
        tl.to(closingGateRef.current, {
          opacity: 1
        })
        tl.to(openingGateRef.current, {
          opacity: 0
        })
      })

      let timer = setTimeout(() => {
        setDisabledDropdown(false)
      }, 2800)

      return () => {
        ctx2.revert();
        clearTimeout(timer)
      }
    } else {
      if (initial) {
        closingGateRef.current.play()
        if (Math.floor(openingGateRef.current.currentTime) > 0) openingGateRef.current.currentTime = 0;

        let ctx2 = gsap.context(() => {
          const tl = gsap.timeline()
          tl.from(bioContentRef.current, {
            delay: 0.5,
            duration: .5,
            opacity: 1
          })
          tl.from(bioContainerRef.current, {
            delay: 0.6,
            duration: 0.8,
            scaleX: 1
          }, "<")
          tl.from(openingGateRef.current, {
            opacity: 0
          })
          tl.from(closingGateRef.current, {
            opacity: 1
          })
        })

        return () => ctx2.revert()
      }
    }
  }, [openGapura])

  const clickEnterBtn = () => {
    setIsShowBG(true)
    setOpenGapura(!openGapura)
    if (isToggled) setIsToggled(!isToggled)
  }

  useEffect(() => {
    const handleResize = () => {
      if (currWindowWidth < window.innerWidth) {
        if (screenW < 640) {
          if (openGapura) {
            bioContainerRef.current.style.transform = "translate(-50%)"
          } else {
            bioContainerRef.current.style = null
          }
        }
      } else {
        // re-init opening gate image pada device hp saat orientation dari landscape ke portrait        
        // if (replacedVid == OpeningGateMobReversedGif) openingGateMobRef.current.classList.add("opacity-0")
        if (window.innerWidth < 640) {
          if (openGapura) {
            // openingGateMobRef?.current.classList.add("opacity-0")
            bioContainerRef.current.style.transform = "translate(-50%)"
            setIsShowBG(true)
          } else {
            bioContainerRef.current.style = null
            setIsShowBG(false)
          }
        }
      }

      setCurrWindowWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [currWindowWidth, openGapura])

  const changeEnterFont = (val) => {
    setIsHover(val)
  }

  return (
    <>
      <section className="h-screen relative">
        {/* video area */}
        <div className={clsx("absolute bottom-0 -z-10", { hidden: isShowBG })} >
          <video ref={animationVideo} src={currWindowWidth >= 1024 ? Animation02 : currWindowWidth >= 640 ? Animation03 : Animation01} playsInline preload="metadata" className="w-full object-cover bg-center"></video>
        </div>
        <div className={clsx("absolute bottom-0 -z-10", { "opacity-0": !isShowBG, "opacity-100": isShowBG })}>
          <div className="relative w-full bg-center">
            <video ref={closingGateRef} src={currWindowWidth >= 1024 ? OpeningGateReversed : currWindowWidth >= 640 ? OpeningGateTabletReversed : OpeningGateMobReversed} playsInline preload="metadata" className="relative bottom-0 opacity-0 w-full object-cover bg-center"></video>
            <video ref={openingGateRef} src={currWindowWidth >= 1024 ? OpeningGateDesk : currWindowWidth >= 640 ? OpeningGateTablet : OpeningGateMob} playsInline preload="metadata" className="absolute bottom-0 w-full object-cover bg-center"></video>
          </div>
        </div>
        {/* bottom-14 */}
        <div ref={bioContainerRef} className="top-[calc(18vh+56px)] sm:top-[calc(18vh+64px)] h-[calc(100vh-(18vh+56px))] sm:h-[calc(100vh-(18vh+64px))] overflow-y-scroll absolute flex justify-center pt-10 bg-[#6c615b] left-1/2 -translate-x-1/2 scale-x-0 w-3/4 xs:w-[74%] sm:w-[70%] lg:w-3/4 xl:w-3/5 2xl:w-[58%]">
          <div ref={bioContentRef} className="opacity-0 w-[90%] bio-content" >
            <div className="text-center text-white">
              <h1 className="font-thin inline-block font-sloopScriptPro text-2xl sm:text-3xl">To continue our parents' and grandparents' legacy</h1>
              {bioPs.map((p, i) => (
                <p key={i} className="font-extralight font-headlines tracking-wide bio-content__paragraph text-sm sm:text-sm">{p}</p>
              ))}
            </div>
            <div className="menu-card-container__outer">
              <div className="menu-card-container menu-card-container--grid mb-5" >
                {
                  tiles.map((t, i) => (
                    <div key={i} className="w-full h-full text-center text-white font-extralight menu-card-content">
                      <div className="tracking-wide text-center">
                        {/* w-full */}
                        {t.isBlank ? (
                          <a href={t.link} target="_blank" className="uppercase font-headlines text-xs sm:text-sm">
                            <picture>
                              <source type="image/webp" srcSet={t.img.webpSrcSet} sizes={tileSizes} />
                              <img
                                width="100"
                                src={t.img.src}
                                srcSet={t.img.srcSet}
                                sizes={tileSizes}
                                className="w-full"
                                alt={t.title}
                                loading="lazy"
                                decoding="async"
                              />
                            </picture>
                            {t.title}
                          </a>
                        ) : (
                          <>
                            <Link to={t.link} className="uppercase font-headlines text-xs sm:text-sm">
                              <picture>
                                <source type="image/webp" srcSet={t.img.webpSrcSet} sizes={tileSizes} />
                                <img
                                  width="100"
                                  src={t.img.src}
                                  srcSet={t.img.srcSet}
                                  sizes={tileSizes}
                                  className="w-full"
                                  alt={t.title}
                                  loading="lazy"
                                  decoding="async"
                                />
                              </picture>
                              {t.title}
                            </Link>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <button ref={enterBtnRef} type="button" onClick={clickEnterBtn} onMouseOver={() => changeEnterFont(true)} onMouseLeave={() => changeEnterFont(false)} className={clsx("absolute top-[60%] sm:top-[40%] left-1/2 -translate-x-1/2 bg-transparent font-sloopScriptPro text-3xl", { "hidden": !showEnterFont, "text-white": !isHover, "text-[#6b5327]": isHover })}>Enter</button>
    </>
  );
}

export default MonkeyAnimationComponent
